var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.2 17.4 8.5-8.5-1.3-1.4-7.2 7.2-3.6-3.6-1.3 1.3 5 5ZM12 24a11.7 11.7 0 0 1-8.5-3.5A12.1 12.1 0 0 1 1 7.3 12.1 12.1 0 0 1 12 0a11.7 11.7 0 0 1 8.5 3.5A12.1 12.1 0 0 1 23 16.7 12.1 12.1 0 0 1 12 24Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSolid);
export default __webpack_public_path__ + "static/media/check-circle-solid.ca8d1f1a5c7e80b50dab78c3b3574bcf.svg";
export { ForwardRef as ReactComponent };